export const LogoMark = ({ size = 34 }) => (
  <img src="/favicon.png" width={size} height={size} alt="" aria-hidden="true" />
);

export const Logo = ({ light = false, large = false }) => (
  <span className="flex flex-col items-start">
    <img
      src="/stj-logo.png"
      alt="STJ Innovations — official logo"
      className={`w-auto ${large ? "h-16 sm:h-20" : "h-12 sm:h-14"}`}
    />
    <span className={`mt-1 block whitespace-nowrap font-mono text-[9px] uppercase tracking-[0.28em] ${light ? "text-slate-400" : "text-steel"}`}>
      Clean Spaces | Better Tomorrow
    </span>
  </span>
);
